import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'
import { LoginPayload } from '../hooks/useAuth'
import LoginForm from '../components/LoginForm'
import { AxiosError } from 'axios'
import { Alert } from '@/common'
import AuthLayout from '../components/AuthLayout'

export default function Login({
  login,
  isLoggingIn
}: {
  login: (payload: LoginPayload) => void
  isLoggingIn: boolean
}) {
  const { t } = useTranslation()
  const [serverError, setServerError] = useState<string | null>(null)

  const onLogin = useCallback(
    async (payload: LoginPayload) => {
      setServerError(null)
      try {
        return await login(payload)
      } catch (err) {
        if (err instanceof AxiosError && err.response?.status === 401) {
          setServerError('login.errors.unauthorized')
        } else {
          setServerError('login.errors.general')
        }
      }
    },
    [login]
  )

  return (
    <AuthLayout>
      <div className="flex flex-col items-center space-y-4 w-full max-w-md">
        <div className="w-full space-y-4">
          <p className="text-center">{t('login.description')}</p>
        </div>
        <div className="w-full space-y-4">
          {serverError && <Alert type="error">{t(serverError)}</Alert>}
          <LoginForm login={onLogin} isLoggingIn={isLoggingIn} />
        </div>
        <div className="text-sm px-10 text-center">
          <Trans
            i18nKey="login.dontHaveAnAccount"
            components={{
              Link: <Link className="text-green-600 underline" to="/signup" />
            }}
          />
        </div>
      </div>
    </AuthLayout>
  )
}
